<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-form ref="form">
        <v-card-title>
          <span class="headline">Edit User</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-show="!!error"
            text
            prominent
            type="error"
            icon="mdi-alert-circle"
            >{{ error }}</v-alert
          >
          <v-alert
            v-show="!!success"
            text
            prominent
            type="success"
            icon="mdi-cloud-check"
            >Succesfully Edited</v-alert
          >
          <v-container class="text-center" v-if="loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
          </v-container>
          <v-container v-else>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedItem.Name"
                  label="Name"
                  required
                  :rules="nameRules"
                  maxlength="50"
                  counter
                  :disabled="success"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.UserRole"
                  :items="userRoles"
                  item-text="name"
                  item-value="name"
                  dense
                  label="Select Role"
                  :disabled="success"
                ></v-autocomplete> </v-col
              ><v-col cols="8" sm="4" md="8">
                <v-autocomplete
                  v-model="editedItem.DepartmentId"
                  :items="departments"
                  item-text="Name"
                  item-value="Id"
                  dense
                  label="Select Department"
                  :disabled="success"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" sm="2" md="4">
                <v-btn
                  color="primary"
                  depressed
                  v-on:click="toggleDepartmentDialog"
                  :disabled="success"
                  >Departments</v-btn
                >
              </v-col>
              <v-col cols="9" sm="4" md="9">
                <v-autocomplete
                  v-model="editedItem.TitleId"
                  :items="titles"
                  item-text="Name"
                  item-value="Id"
                  dense
                  label="Select Title"
                  :disabled="success"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" sm="2" md="3">
                <v-btn
                  color="primary"
                  depressed
                  v-on:click="toggleTitleDialog"
                  :disabled="success"
                  >Titles</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            v-show="!success && !loading"
            @click="save"
            >Save</v-btn
          >
          <v-btn color="grey darken-1" text @click="closeUpdateDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  CLOSE_UPDATE_USER_DIALOG,
  OPEN_UPDATE_USER_DIALOG,
  UPDATE_SUB_USER,
} from "../../store/modules/user";
import {
  TOGGLE_DEPARTMENT_DIALOG,
  TOGGLE_TITLE_DIALOG,
  FETCH_DEPARTMENTS,
  FETCH_TITLES,
} from "../../store/modules/digistaff";

export default {
  computed: {
    dialog: {
      get() {
        return this.$store.state.user.subUser.updateDialog;
      },
      set(val) {
        if (val) {
          this.openUpdateDialog();
        } else {
          this.closeUpdateDialog();
        }
      },
    },
    ...mapState("user", {
      loading: (state) => state.subUser.isLoading,
      error: (state) => state.subUser.updateError,
      success: (state) => state.subUser.updateSuccess,
      userRoles: (state) => state.subUser.userRoles,
      selectedSubUser: (state) => state.subUser.selectedSubUser,
    }),
    ...mapState("digistaff", {
      departments: (state) => state.departments,
      titles: (state) => state.titles,
    }),
  },
  created() {
    if (!this.selectedSubUser) {
      this.closeUpdateDialog();
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.fetchDepartments();
        this.fetchTitles();

        Object.assign(this.editedItem, {
          UserRole: "",
          Name: "",
          DepartmentId: "",
          TitleId: "",
        });
      }
    },
    selectedSubUser(val) {
      if (val) {
        Object.assign(this.editedItem, {
          UserRole: val.UserRole,
          Name: val.Name,
          DepartmentId: val.DepartmentId,
          TitleId: val.TitleId,
        });
      }
    },
  },
  methods: {
    ...mapActions("user", {
      openUpdateDialog: OPEN_UPDATE_USER_DIALOG,
      closeUpdateDialog: CLOSE_UPDATE_USER_DIALOG,
      updateUser: UPDATE_SUB_USER,
    }),
    ...mapActions("digistaff", {
      toggleDepartmentDialog: TOGGLE_DEPARTMENT_DIALOG,
      fetchDepartments: FETCH_DEPARTMENTS,
      toggleTitleDialog: TOGGLE_TITLE_DIALOG,
      fetchTitles: FETCH_TITLES,
    }),
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.updateUser({
        userId: this.selectedSubUser.Id,
        user: this.editedItem,
      });
    },
  },
  data: () => ({
    nameRules: [(v) => !!v || "User name is required"],
    roleRules: [(v) => !!v || "User role is required"],
    departmentRules: [(v) => !!v || "Department is required"],
    titleRules: [(v) => !!v || "Title is required"],
    editedItem: {
      UserRole: "",
      Name: "",
      DepartmentId: "",
      TitleId: "",
    },
  }),
};
</script>
